import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import type { ExchangeFees, FiatFees, WithdrawalFeeCrypto } from 'src/app/models/exchange-fees';
import { FeesService } from 'src/app/api/fees.service';
import { AuthService } from 'src/app/api/auth.service';
import { FeeTabs } from 'src/app/models/fees';
import { ChatService } from 'src/app/services/chat.service';
import { CurrenciesService } from 'src/app/api/currencies.service';
import { Currency } from 'src/app/models/currency';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-fees',
  templateUrl: './fees-page.component.html',
  styleUrls: ['./fees-page.component.scss']
})
export class FeesPageComponent implements OnInit, OnDestroy {
  loading = false;
  error: string = null;

  FeeTabs = FeeTabs;
  selectedTab: FeeTabs;
  exchangeFees: ExchangeFees;
  withdrawalFeeCrypto: WithdrawalFeeCrypto[];
  fiatFees: FiatFees;
  isMobileWebView = false;

  queryParamsChangeSubscription: Subscription;

  constructor(
    private auth: AuthService,
    private currenciesService: CurrenciesService,
    private feesService: FeesService,
    private route: ActivatedRoute,
    private chatService: ChatService
  ) { }

  async ngOnInit() {
    this._handleQueryParamsChange();
    await this.getExchangeFees();
    this.getCryptoTokens();

    // TODO: request fees
    // this.getFiatFees();
  }

  ngOnDestroy() {
    this.queryParamsChangeSubscription?.unsubscribe();
  }

  private _handleQueryParamsChange() {
    this.queryParamsChangeSubscription = this.route.queryParamMap.subscribe(params => {
      this.isMobileWebView = params.get('mobile') === 'true';
      if (this.isMobileWebView) {
        this.chatService.destroy();
      }
    });
  }

  getExchangeFees() {
    this.loading = true;
    this.error = null;

    return this.feesService.getExchangeFees().pipe(
      tap(response => {
        this.loading = false;
        this.exchangeFees = response;
      }, (err) => {
        this.loading = false;
        this.error = err.errors[0].message;
      })
    ).toPromise();
  }

  getCryptoTokens() {
    this.currenciesService.getCrypto().subscribe(currencies => this._extendFeeCrypto(currencies));
  }

  private _extendFeeCrypto(currencies: Currency[]) {
    this.withdrawalFeeCrypto = this.exchangeFees?.withdrawalFees?.map(feeCrypto => {
      const name = currencies?.find(({ code }) => code === feeCrypto.currency)?.name;
      return { ...feeCrypto, name };
    });
  }

  getFiatFees() {
    this.loading = true;
    this.error = null;

    this.feesService.getFiatFees().subscribe(response => {
      this.loading = false;
      this.fiatFees = response;
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

  handleTabChange(tab: FeeTabs) {
    this.selectedTab = tab;
  }

  isLoggedIn() {
    return this.auth.getToken();
  }
}
